import { useState } from 'react';

interface MergeDialogProps {
  selectedIds: number[];
  onMerge: (targetId: number, sourceIds: number[]) => void;
  onClose: () => void;
  isPending: boolean;
}

export default function MergeDialog({ selectedIds, onMerge, onClose, isPending }: MergeDialogProps) {
  const [targetId, setTargetId] = useState<number>(selectedIds[0]);

  const sourceIds = selectedIds.filter((id) => id !== targetId);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        <h3 className="text-lg font-bold text-gray-900 mb-4">Verfahren zusammenführen</h3>

        <p className="text-sm text-gray-600 mb-4">
          Wählen Sie das Ziel-Verfahren. Alle Inserate der anderen Verfahren werden dorthin verschoben und die Quell-Verfahren gelöscht.
        </p>

        <div className="space-y-2 mb-6">
          {selectedIds.map((id) => (
            <label
              key={id}
              className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-colors ${
                targetId === id ? 'border-purple-500 bg-purple-50' : 'border-gray-200 hover:bg-gray-50'
              }`}
            >
              <input
                type="radio"
                name="target"
                value={id}
                checked={targetId === id}
                onChange={() => setTargetId(id)}
                className="text-purple-600"
              />
              <span className="text-sm">
                <span className="font-medium">Verfahren #{id}</span>
                {targetId === id && (
                  <span className="ml-2 text-purple-700 font-medium">(Ziel)</span>
                )}
              </span>
            </label>
          ))}
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="btn btn-text text-neutral-600 enabled:hover:text-neutral-800 focus-visible:ring-neutral-500 text-sm px-4 py-2"
          >
            Abbrechen
          </button>
          <button
            onClick={() => onMerge(targetId, sourceIds)}
            disabled={isPending || sourceIds.length === 0}
            className="btn btn-primary bg-purple-600 enabled:hover:bg-purple-700 focus-visible:ring-purple-500"
          >
            {isPending ? 'Wird zusammengeführt...' : `${sourceIds.length} Verfahren zusammenführen`}
          </button>
        </div>
      </div>
    </div>
  );
}
